import Swal from "sweetalert2";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from "@angular/forms";
import { LgaDto, CommunityDto } from "@cradua/data";

@Component({
  selector: "mrsoftapps-community-view",
  templateUrl: "./community-view.component.html",
  styleUrls: ["./community-view.component.css"],
})
export class CommunityViewComponent implements OnInit {
  @Input()
  communities: CommunityDto[];
  @Input()
  lgas: LgaDto[];
  communityForm: FormGroup;
  control = new FormControl();
  @Output()
  changeEmit = new EventEmitter<CommunityDto>();
  @Output()
  deleteEvent = new EventEmitter<any>();
  @Output()
  printEvent = new EventEmitter<any>();

  SubscriberId = "5ca0c7a7ef1d2e5760762ebd";
  filteredDelete: Array<any> = [];
  loading = true;
  selectedLga: any;
  filteredCommunity: Array<any> = [];
  status: boolean;
  selectedLgaId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.communityForm = this.fb.group({ Communities: this.fb.array([]) });
    // this.setCommunity();
  }

  clickme(value) {
    console.log("click ", value);
  }

  // method to display lgas
  setCommunity() {
    const control = this.communityForm.controls.Communities as FormArray;
    this.filteredCommunity.forEach((e) => {
      control.push(
        this.fb.group({
          CommunityName: e.CommunityName,
          SerialNo: e.SerialNo,
          LgaId: e.LgaId,
          id: e.id,
        }),
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.communityForm.controls.Communities as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter community
  selectLga(event: string) {
    this.filteredCommunity = this.communities.filter((s) => s.LgaId === event);
    this.selectedLgaId = event;
    const control = this.communityForm.controls.Communities as FormArray;

    if (this.filteredCommunity.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setCommunity();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Lga
  addCommunity() {
    console.log("community");
    const control = this.communityForm.controls.Communities as FormArray;
    control.insert(
      0,
      this.fb.group({
        CommunityName: ["", Validators.required],
        SerialNo: ["", Validators.required],
        LgaId: this.selectedLgaId,
        id: null,
      }),
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteCommunity(index, value) {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this imaginary file!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const control = this.communityForm.controls.Communities as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.communities.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.communities[i].id);
            }
          }
        }
        Swal.fire(
          "Deleted!",
          "Your imaginary file has been deleted.",
          "success",
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your imaginary file is safe :)", "error");
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = "community";
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift("community");
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
